import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'empathy-toggle',
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss'
})
export class ToggleComponent {
  @Input() disabled: boolean;
  @Input() label = '';

  @Input({ required: true })
  control!: FormControl;

  value = false;
}
